<form fxLayout="column" fxLayoutGap="20px" [formGroup]="datiFattForm" #form>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
    <div>
      <h2 class="divider-title">
        Spedizione fattura
      </h2>
    </div>
    <mat-divider fxFlex="auto"></mat-divider>
  </div>

  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px" class="modalita-spedizione">

    <div fxLayout="row" fxLayoutGap="10px" *ngIf="dataService.prodotto?.tipo_utenza != 'DOM'">
      <ng-container *ngIf="datiAnaForm.get('tipoCliente')?.value == '0'">
        <mat-form-field>
          <input [required]="setRequired(datiFattForm.get('sdi'))" matInput placeholder="Codice SDI" formControlName="sdi" [maxLength]="7">
          <mat-error *ngIf="datiFattForm.get('sdi')?.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error *ngIf="datiFattForm.get('sdi')?.hasError('pattern')">
            <strong>Inserire valore alfanumerico</strong>
          </mat-error>
        </mat-form-field>
      </ng-container>
      <mat-form-field>
        <input [required]="setRequired(datiFattForm.get('pec'))" matInput placeholder="Pec" formControlName="pec" oninput="this.value = this.value.toLowerCase()">
        <mat-error *ngIf="datiFattForm.get('pec')?.hasError('required')">
          <strong>Campo obbligatorio</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="modalitaSpedizione">
      <mat-radio-button value="0" fxLayoutAlign="start start">
        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
          E-mail
        </div>
      </mat-radio-button>
      <ng-container *ngIf="dataService.user != 2">
        <mat-radio-button value="1" fxLayoutAlign="start start">
          Cartacea
        </mat-radio-button>
      </ng-container>
    </mat-radio-group>
  </div>
  <div class="spedizione-options" fxLayout="column" fxLayoutGap="10px">

    <mat-card *ngIf="datiFattForm.get('modalitaSpedizione')!.value == '0'" fxLayout="row wrap" fxLayoutGap="20px" fxLayoutAlign="start center">
      <ng-container formArrayName="mails">
        <ng-container *ngFor="let mail of mails.controls; index as i">
          <mat-form-field>
            <input [required]="setRequired(mail)" [formControlName]="i" matInput placeholder="E-mail" oninput="this.value = this.value.toLowerCase()">
            <mat-error *ngIf="mail.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
            <button *ngIf="i != 0" matSuffix mat-icon-button aria-label="Elimina" (click)="removeMail(i)">
              <mat-icon color="warn">remove_circle</mat-icon>
            </button>
          </mat-form-field>
        </ng-container>
      </ng-container>

      <button mat-icon-button (click)="addMail()" *ngIf="mails.value.length < 3">
        <mat-icon color="primary">add_circle</mat-icon>
      </button>
    </mat-card>
    <mat-card *ngIf="datiFattForm.get('modalitaSpedizione')!.value == '1'" class="indirizzo-spedizione">
      <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="tipoIndirizzoCart">
        <mat-radio-button value="0">Indirizzo uguale a quello
          {{dataService.datiAnagrafici?.get('tipoCliente')?.value == '0' ? 'legale': 'di residenza'}}
        </mat-radio-button>
        <mat-radio-button value="1">Indirizzo uguale a quello di fornitura
        </mat-radio-button>
        <mat-radio-button value="2" id="nuovo-indirizzo">
          <div fxLayout="row" fxLayoutGap="10px">
            Nuovo indirizzo
          </div>
          <div fxLayout="row" *ngIf="datiFattForm.get('tipoIndirizzoCart')!.value == '2'" class="indirizzo-form">
            <app-indirizzo [indirizzoForm]="indirizzoForm" options="presso"></app-indirizzo>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </mat-card>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title">
          Fatturazione
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div>
      <mat-radio-group formControlName="accorpaFatture" fxLayout="column" fxLayoutGap="10px">
        <mat-radio-button value="0" [disabled]="fatturaUnica">Invio unica fattura per tutti i POD o PDR</mat-radio-button>
        <mat-radio-button value="1">Invio fattura singola per ogni POD o PDR</mat-radio-button>
      </mat-radio-group>
    </div>

  </div>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
    <div>
      <h2 class="divider-title">
        Pagamento
      </h2>
    </div>
    <mat-divider fxFlex="auto"></mat-divider>
  </div>

  <div fxLayout="column" fxLayoutGap="10px">

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h3 class="divider-title">
          Modalità
        </h3>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="modalita">
      <mat-radio-group fxLayout="column" fxLayoutGap="10px" formControlName="modalitaPagamento" fxFlexFill>
        <mat-radio-button value="0">
          Domiciliazione bancaria
          <mat-card *ngIf="datiFattForm.get('modalitaPagamento')!.value == '0'">
            <!-- <mat-form-field>
                            <input matInput placeholder="Banca" formControlName="banca">
                        </mat-form-field> -->
            <mat-form-field>
              <input matInput [required]="setRequired(datiFattForm.get('iban'))" placeholder="Iban" formControlName="iban" [maxlength]="ibanMaxLength" [minlength]="ibanMinLength">
              <mat-error *ngIf="datiFattForm.get('iban')?.hasError('minlength') || datiFattForm.get('iban')?.hasError('maxlength')">
                Lunghezza errata
              </mat-error>
              <mat-error *ngIf="datiFattForm.get('iban')?.hasError('pattern')">
                Pattern errato
              </mat-error>
              <mat-error *ngIf="datiFattForm.get('iban')?.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
            </mat-form-field>
            <div fxLayout="column" fxLayoutGap="10px">
              <h2 class="title-section">Titolare conto</h2>
              <form fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="campi-domiciliazione" formGroupName="titolareConto">
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('nome'))" placeholder="Nome" formControlName="nome">
                  <mat-error *ngIf="titolareConto.controls.nome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('cognome'))" placeholder="Cognome" formControlName="cognome">
                  <mat-error *ngIf="titolareConto.controls.cognome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('codiceFiscale'))" placeholder="Codice fiscale" formControlName="codiceFiscale">
                  <mat-error *ngIf="titolareConto.controls.codiceFiscale.hasError('pattern')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                  <mat-error *ngIf="titolareConto.controls.codiceFiscale.hasError('required')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                </mat-form-field>
                <ng-container *ngIf="dataService.prodotto?.tipo_utenza != 'DOM'">
                  <mat-form-field>
                    <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('ragioneSociale'))" placeholder="Ragione sociale" formControlName="ragioneSociale">
                    <mat-error *ngIf="titolareConto.controls.ragioneSociale.hasError('required')">
                      <strong>Campo obbligatorio</strong>
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <input matInput [required]="setRequired(datiFattForm.get('titolareConto')!.get('piva'))" placeholder="Partita IVA" formControlName="piva" [maxLength]="11">
                  </mat-form-field>
                </ng-container>
              </form>
            </div>
            <div fxLayout="column" fxLayoutGap="10px">
              <h2 class="title-section">Sottoscrittore mandato</h2>
              <form fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" class="campi-domiciliazione" formGroupName="sottoscrittore">
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('sottoscrittore')!.get('nome'))" placeholder="Nome" formControlName="nome">
                  <mat-error *ngIf="sottoscrittore.controls.nome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('sottoscrittore')!.get('cognome'))" placeholder="Cognome" formControlName="cognome">
                  <mat-error *ngIf="sottoscrittore.controls.cognome.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [required]="setRequired(datiFattForm.get('sottoscrittore')!.get('codiceFiscale'))" placeholder="Codice fiscale" formControlName="codiceFiscale">
                  <mat-error *ngIf="sottoscrittore.controls.codiceFiscale.hasError('pattern')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                  <mat-error *ngIf="sottoscrittore.controls.codiceFiscale.hasError('required')">
                    <strong>Pattern errato</strong>
                  </mat-error>
                </mat-form-field>
              </form>
            </div>
          </mat-card>
        </mat-radio-button>
        <ng-container *ngIf="(dataService.user == 2 && dataService.prodotto?.tipo_utenza == 'BUS') || dataService.user != 2">
          <mat-radio-button value="1">Bonifico</mat-radio-button>
        </ng-container>
        <!-- <ng-container *ngIf="(dataService.user == 2 && dataService.prodotto?.tipo_utenza == 'DOM') || dataService.user != 2">
          <mat-radio-button value="2">Bollettino postale</mat-radio-button>
        </ng-container> -->
      </mat-radio-group>
    </div>
  </div>



</form>